export default __webpack_public_path__ + "static/media/search_bar.f3cac778.png";